import { generatePath } from 'react-router-dom';
import { RoutePaths } from 'src/core/router/RoutePaths';

type Links = {
    list?: () => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemDetails?: (id: string | number) => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemEdit?: (id: string | number) => string;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    process?: (id: string | number) => string;

    create?: () => string;

    index?: () => string;
};

export type EntityNames =
    | 'index'
    | 'partners'
    | 'merchants'
    | 'loanApplications'
    | 'transaction';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const EntityLinks: { [key in EntityNames]: Links } = {
    index: {
        index: () => RoutePaths.index,
    },
    partners: {
        list: () => RoutePaths.partners,
        create: () => RoutePaths.partnersCreate,
        itemDetails: (id) => generatePath(RoutePaths.partnersDetails, { id }),
        itemEdit: (id) => generatePath(RoutePaths.partnersEdit, { id }),
    },
    merchants: {
        list: () => RoutePaths.merchants,
        itemDetails: (id) => {
            return generatePath(RoutePaths.merchantDetails, {
                id: String(id),
            });
        },
    },
    loanApplications: {
        list: () => RoutePaths.loanApplications,
        itemDetails: (id) => {
            return generatePath(RoutePaths.loanApplicationDetails, {
                id: String(id),
            });
        },
    },
    transaction: {
        list: () => RoutePaths.transactions,
    },
};
